module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-23.6e3043bd.png";